import { CHAT_STATUS_ACTIVE } from '@evo/chat-core';

import * as c from '../libs/constants';
import { getPageType, getParamByName } from '../libs/utils';

export const BesidaModel = (initialAppData, userRole) => ({
    userRole,
    onPortal: initialAppData.onPortal,
    withoutButton: initialAppData.withoutButton,
    userHasCompany: initialAppData.userHasCompany,
    userHasC2CCompany: initialAppData.userHasC2CCompany,
    socketViewStore: {
        chats: {}
    },
    userId: initialAppData.user_id,
    autoKnockKnock: initialAppData.auto_knock_knock,
    theme: initialAppData.theme,
    isInBuyerCabinet: initialAppData.isInBuyerCabinet,
    pageType: getPageType(userRole),
    chatsStatus: CHAT_STATUS_ACTIVE,

    // can serve as product page or product list locator
    contextItemId: initialAppData.context_item_id,
    contextItemType: initialAppData.context_item_type,
    contextItemPrice: initialAppData.context_item_price,
    contextItemCurrency: initialAppData.context_item_currency,
    contextSource: navigator.userAgent,
    contextDescription: initialAppData.context_description,
    contextMeta: initialAppData.context_meta,
    socialLinks: initialAppData.social_auth,

    chatMsgText: '',
    inputBlocked: false,
    currentRoomName: null,
    platform: 'web',
    source: navigator.userAgent,
    device: initialAppData.isMobile ? 'phone' : 'desktop',
    locale: initialAppData.locale || c.DEFAULT_LOCALE,
    errors: {
        [c.ERROR_NETWORK_UNAVAILABLE]: navigator.onLine === false
    },

    isDeveloper: getParamByName('is_developer') || false,
    visible: false,
    newMsgMarkShown: false,
    stayInDialog: true,
    activeAuthTab: c.CHAT_AUTH_SOCIAL,

    // it could be a function, or rethrown dispatched method
    notification: {
        error: null,
        alert: null,
        info: null,
    },

    isLoadingData: {
        login: false,
        register: false,
        chats: false,
        history: false,
        chatChannel: false,
        clientInfo: false,
        companyInfo: false,
    },

    goBotOnMsg: false,
    goBotOnTyping: false,
    launchOnce: {},
    isOpen: {},

    loginFields: {
        phoneEmail: '',
        password: '',
    },
    registerFields: {
        userName: '',
        email: '',
        password: '',
        agreement: true,
    },
    pow: {
        comp: null,
        pref: null,
        nonce: null,
    },
    fieldsErrors: {},

    analyticsQueue: {
        openDialog: null
    },
    registerTrackAnal: {
        label: `${getPageType(userRole)}/txt.register.customer`,
        landing_page_name: getPageType(userRole),
        leadid: null,
    },


    windowHeight: window.innerHeight,
    chatHeightCoefficient: 1,

    dialogScroll: {
        inner: null,
        outer: null,
        height: null,
        offsetHeight: null,
    },

    dialogContainer: null,
    dialogPrevHeight: null,
    dialogOldHeight: null,

    isNewCabinet: initialAppData.is_new_cabinet || false,

    // client ban section
    clientInfo: {},
    clientsUserId: null,
    activeClientTab: c.CHAT_CLIENT_INFO,

    // company ban section
    companyInfo: {},
    companyBanId: null,
    activeCompanyTab: c.CHAT_COMPANY_INFO,

    banChatListCollapsed: true,
    prevOpenedRoomIdent: null,

    rerenderCounter: 0,
    rendTriggerForSocket: false,

    imagePopup: {
        open: false,
        msgId: null,
    },
});
